import React from "react";
import { createMarkup } from "../../helpers";

const Checkboxes = ({ label, sublabel = "", reqd, data, values, click }) => {
	const labels = data.map((item, index) => {
		return !item.hide ? (
			<label key={index}>
				<input
					type="checkbox"
					name={item.name}
					value={item.val}
					defaultChecked={values.includes(item.val)}
					onClick={(e) => click(item.name, e.target.checked, e.target.value)}
				/>
				<span>{item.label ? item.label : item.val}</span>
			</label>
		) : null;
	});

	return (
		<div>
			<label>
				{label} {reqd && <span className="reqd">*</span>}
			</label>

			{sublabel && (
				<p
					style={{ marginTop: "0" }}
					dangerouslySetInnerHTML={createMarkup(sublabel)}
				/>
			)}
			<div>{labels}</div>
		</div>
	);
};

export default Checkboxes;
